import { useState } from "react";
import { Button, TextField, Autocomplete } from "@mui/material";
import { getCaeToken } from "../../services";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { useTranslation } from 'react-i18next';

const SOFTWARE_PROVIDER_OPTIONS = ["Taaf"];

export default function CaeToken() {
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    token: "",
    flashMessage: null,
  });
  const [softwareProvider, setSoftwareProvider] = useState("");
  const [error, setError] = useState(null);

  const trimmedProvider = softwareProvider.trim();
  const canGenerate = trimmedProvider.length > 0 && trimmedProvider.length <= 100;

  const generateToken = async () => {
    if (!canGenerate) {
      setError(t('profile.softwareProviderRequired'));
      return;
    }
    setError(null);
    const result = await getCaeToken(trimmedProvider);

    setState({
      ...state,
      token: result?.token || "",
    });
  };

  const copyToken = async () => {
    await navigator.clipboard.writeText(state.token);
    showCopyFlashMessage();
  };

  const showCopyFlashMessage = () => {
    setState({
      ...state,
      flashMessage: t('profile.tokenCopied'),
    });

    setTimeout(() => {
      setState({
        ...state,
        flashMessage: null,
      });
    }, 2000);
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px", maxWidth: "400px" }}>
        <Autocomplete
          freeSolo
          options={SOFTWARE_PROVIDER_OPTIONS}
          value={softwareProvider}
          onChange={(_, newValue) => setSoftwareProvider(newValue || "")}
          onInputChange={(_, newInput) => setSoftwareProvider(newInput || "")}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('profile.softwareProvider')}
              placeholder={t('profile.softwareProviderPlaceholder')}
              size="small"
              error={Boolean(error)}
              helperText={error || ""}
              inputProps={{ ...params.inputProps, maxLength: 100 }}
            />
          )}
        />
        <div>
          <Button
            className="btn-buscador"
            onClick={() => generateToken()}
            disabled={!canGenerate}
          >
            {t('profile.generateToken')}
          </Button>
        </div>
      </div>
      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        {state.token && (
          <>
            <div
              style={{
                background: "#e6e6e6",
                padding: "5px",
                border: "1px solid #ccc",
              }}
            >
              <code style={{ overflowWrap: "anywhere" }}>{state.token}</code>
            </div>
            <div>
              <HiClipboardDocumentList onClick={copyToken} />
            </div>
          </>
        )}
      </div>
      {state.flashMessage && <p className="flash-message">{state.flashMessage}</p>}
      <style jsx="true">
        {`
          .flash-message {
            position: fixed;
            bottom: 20px;
            right: 20px;
            background-color: #4caf50; /* green */
            color: white;
            padding: 12px 20px;
            border-radius: 8px;
            font-size: 14px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            pointer-events: none;
            transition: opacity 0.4s ease-in-out;
            z-index: 1000;
          }
        `}
      </style>
    </>
  );
}
